import { useReactiveVar } from '@apollo/client';
import { EmptyState } from '@starryui10/Components/EmptyState';
import { PhotoViewerDialog } from '@starryui10/photoViewer/PhotoViewerDialog';
import React from 'react';
import { avatarImagePopup } from '../cache';
import { useEntryDirectoryEvents } from '../context/EntryDirectoryContext';

export const PhotoPopup = () => {
    const { data, visible } = useReactiveVar(avatarImagePopup);
    const { openEntry } = useEntryDirectoryEvents();

    if (!visible || !data) return null;

    const handleOnClick = () => {
        avatarImagePopup({ visible: false });
        openEntry(Number(data.entryID));
    };

    const preferredName = data?.namePreferred || data?.nameFirst;
    const fullName = `${preferredName} ${data.nameLast}`;

    return (
        <PhotoViewerDialog
            altText={fullName}
            onClose={() => avatarImagePopup({ visible: false })}
            popupHeader={fullName}
            src={data?.largeImage.url}
            emptyState={() => (
                <EmptyState
                    title={`${preferredName} does not have a profile photo yet`}
                    description="You can add a photo by going to the Rez360 page."
                    buttonCaption="Go to add photo"
                    variant="Large"
                    graphic="Entry"
                    showButton
                    onClick={handleOnClick}
                />
            )}
        />
    );
};
